export const taxTypeApplicationsReducer = (
  state = {
    taxTypeApplications: [],
    updating: false,
    updated: false,
    error: null,
    tableDataParam: {
      pageSize: 25,
      currentPage: 1,
      sorts: [{ column: "id", asc: false }],
      filters: []
    }
  },
  action
) => {
  switch (action.type) {
    case "GET_TAX_TYPE_APPLICATIONS_PENDING": {
      state = { ...state, updating: true };
      break;
    }
    case "UPDATE_TAX_TYPE_APPLICATIONS_TABLEDATAPARAM": {
      state = { ...state, tableDataParam: action.payload };

      break;
    }
    case "GET_TAX_TYPE_APPLICATIONS_FULFILLED": {
      state = { ...state, updating: false, updated: true, taxTypeApplications: action.payload.items };
      break;
    }
    case "GET_TAX_TYPE_APPLICATIONS_REJECTED": {
      state = { ...state, updating: false, error: action.payload };
      break;
    }
    case "GET_TAX_TYPE_APPLICATION_PENDING": {
      state = { ...state, updating: true };
      break;
    }
    case "GET_TAX_TYPE_APPLICATION_FULFILLED": {
      let taxTypeApplications = state.taxTypeApplications;
      taxTypeApplications = taxTypeApplications.filter(s => s.id !== action.payload.id);
      taxTypeApplications.push(action.payload);

      state = {
        ...state,
        updating: false,
        updated: true,
        taxTypeApplications
      };
      break;
    }
    case "GET_TAX_TYPE_APPLICATIONS_SELECT_FULFILLED": {
      let taxTypeApplications = state.taxTypeApplications;
      action.payload.forEach(taxTypeApplication => {
        if (!taxTypeApplications.some(t => t.id === taxTypeApplication.id)) {
          taxTypeApplications.push(taxTypeApplication);
        }
      });

      state = {
        ...state,
        updating: false,
        updated: true,
        taxTypeApplications: taxTypeApplications
      };
      break;
    }
    case "GET_TAX_TYPE_APPLICATION_REJECTED": {
      state = { ...state, updating: false, error: action.payload };
      break;
    }

    default: {
    }
  }

  return state;
};

export default taxTypeApplicationsReducer;
